
const AccessBi = () => import('@/views/access/AccessBi');
const AccessSurvey = () => import('@/views/access/AccessSurvey');
const AccessTatic = () => import('@/views/access/AccessTatic');
const AccessCreateSurvey = () => import('@/views/access/AccessCreateSurvey');

const mainWidget = [{
        title: 'รายงานสถิติการเข้าใช้งานระบบ Business Intelligent',
        path: '/admin/widget/:category/:widget_code(151)',
        component: AccessBi
    },
    {
        title: 'รายงานสถิติการเข้าใช้งานระบบ E-Survey และ E-Form',
        path: '/admin/widget/:category/:widget_code(150)',
        component: AccessSurvey
    },
    {
      title: 'จำนวนรายการข้อมูลในระบบฐานข้อมูล ( TATIC - Smart )',
      path: '/admin/widget/:category/:widget_code(152)',
      component: AccessTatic
    },
    {
      title: 'รายงานจำนวนการสร้างและตอบแบบสอบถามใบระบบ E-Survey และ E-Form',
      path: '/admin/widget/:category/:widget_code(153)',
      component: AccessCreateSurvey
    },
]

export default mainWidget.map(data => {
    const { path, title, component, redirect, children } = data

    return {
        path: path,
        name: title,
        component: component,
        redirect: redirect,
        meta: {
            title: title,
            requiresAuth: true,
            breadcrumb: title
        },
        children: children
    }
})